/**
 * Converte a lista de robôs em dados compatíveis com o gráfico de barras de comparação.
 * Itera sobre a lista de relatórios de limpeza e mapeia as métricas por robô para exibição.
 *
 * @param {Array} list Lista de tarefas.
 * @param {Array} cc1Robots Lista de robôs (usados como base do eixo X).
 * @param {Object} intl Instância do useIntl() para formatação de strings internacionalizadas.
 * @returns {Array<Object>} Array de objetos de métricas comparativas por robô.
 */
export function buildRobotComparisonDataFromList(list, cc1Robots, intl) {
    if (
        !list ||
        !Array.isArray(list) ||
        !cc1Robots ||
        !Array.isArray(cc1Robots)
    ) {
        return [];
    }

    const robotStats = {};

    cc1Robots.forEach(r => {
        if (r && r.id) {
            let fallbackName = `Robot ${r.id}`;
            if (intl) {
                fallbackName = intl.formatMessage(
                    {
                        id:
                            'page.robots.cleaning_report.robot_comparison.robot_name_fallback',
                    },
                    { id: r.id }
                );
            }

            robotStats[r.id] = {
                robot_id: r.id,
                name: r.name || r.code || fallbackName,
                tasks: 0,
                time_seconds: 0,
                area: 0,
                daysActive: new Set(),
            };
        }
    });

    list.forEach(task => {
        const robotId = task._robot && task._robot.id;

        if (robotId && robotStats[robotId]) {
            robotStats[robotId].tasks += 1;
            robotStats[robotId].time_seconds += Number(task.clean_time) || 0;
            robotStats[robotId].area += Number(task.clean_area) || 0;

            let dayStr = '';
            if (task.create_time) {
                const [datePart] = String(task.create_time).split('T');
                [dayStr] = datePart.split(' ');
            }
            if (dayStr) {
                robotStats[robotId].daysActive.add(dayStr);
            }
        }
    });

    return Object.values(robotStats).map(stat => {
        const freq = stat.daysActive.size;
        return {
            name: stat.name,
            tasks: stat.tasks,
            time: stat.time_seconds
                ? Number((stat.time_seconds / 3600).toFixed(2))
                : 0,
            area: stat.area,
            frequency: freq,
        };
    });
}
